import { Box, Typography } from '@mui/material';

const NotFound = () => (
    <Box flex={1} display="flex" justifyContent="center" alignItems="center">
        <Typography variant="h1">404 Page Not Found</Typography>
    </Box>
);

export default NotFound;
